<div class="asset-type-field">
  <span class="label" id="asset-type-label">Tipo de activo</span>

  <ng-container *ngIf="!editing; else editor">
    <div class="value-row">
      <span class="value" [class.empty]="!assetType" data-test="asset-type-value">{{ label }}</span>
      <!-- Tooltip estático a propósito: los specs de las vistas que lo alojan montan la plantilla sin PrimeNG. -->
      <button
        *ngIf="canEdit && quotationParametersId"
        pButton
        type="button"
        icon="pi pi-pencil"
        class="p-button-text p-button-sm p-button-rounded"
        aria-label="Cambiar el tipo de activo"
        pTooltip="Cambiar"
        data-test="asset-type-edit"
        (click)="startEdit()"
      ></button>
    </div>
  </ng-container>

  <ng-template #editor>
    <div class="editor-row">
      <p-dropdown
        [options]="options"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="selected"
        [autoDisplayFirst]="false"
        placeholder="Elige el tipo"
        appendTo="body"
        ariaLabelledBy="asset-type-label"
        styleClass="asset-type-dropdown"
      ></p-dropdown>
      <button
        pButton
        type="button"
        icon="pi pi-check"
        label="Guardar"
        class="p-button-sm"
        [disabled]="saving || !selected"
        (click)="save()"
        data-test="asset-type-save"
      ></button>
      <button
        pButton
        type="button"
        icon="pi pi-times"
        class="p-button-text p-button-sm"
        aria-label="Cancelar"
        [disabled]="saving"
        (click)="cancel()"
      ></button>
    </div>
  </ng-template>
</div>

<p-toast position="top-right"></p-toast>
